import React from 'react';
import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';
import HistoryParcelLink from './HistoryParcelLink';
import { HistoryParcelSystem } from './historyLink';

interface ParcelEmptyGuideProps {
    system: HistoryParcelSystem;
    days: number;
    /** 本次查询使用的筛选条件 */
    filters: Record<string, any> | null | undefined;
}

/** 按运单号 / 订单号查询无结果时的空状态引导 */
const ParcelEmptyGuide: React.FC<ParcelEmptyGuideProps> = ({ system, days, filters }) => {
    const { t } = useTranslation();
    return (
        <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
                <div>
                    <div className="text-gray-800">{t('parcelQueryRange.emptyTitle')}</div>
                    <div className="text-xs text-gray-500 mt-1">
                        {t('parcelQueryRange.emptyDescription', { days })}{' '}
                        <HistoryParcelLink system={system} filters={filters} source="emptyResult" />
                    </div>
                </div>
            }
        />
    );
};

const hasNonEmptyFilterValue = (value: unknown): boolean => {
    if (value == null) {
        return false;
    }
    if (Array.isArray(value)) {
        return value.some((item) => String(item ?? '').trim().length > 0);
    }
    return String(value).trim().length > 0;
};

/** 触发条件：查询条件含运单号或订单号（兼容 hash 解码成数组的情况） */
export const hasTrackingOrOrderNumber = (filters: Record<string, any> | null | undefined): boolean =>
    hasNonEmptyFilterValue(filters?.trackingNumbers) || hasNonEmptyFilterValue(filters?.channelOrderNumber);

export default ParcelEmptyGuide;
